<script setup>
    import {computed, ref} from 'vue'

    import {
        ChevronDownIcon,
        MinusIcon,
        StopIcon
    } from '@heroicons/vue/outline'
    import SidebarNavigationSubItem from "./sidebarNavigationSubItem.vue";

    const props = defineProps({
        item: {
            type: Object,
            required: true
        },
        isFirst: {
            type: Boolean,
            required: false,
            default: false
        },
        isLast: {
            type: Boolean,
            required: false,
            default: false
        },
        notificationCount: {
            type: Number,
            required: false,
            default: 0,
        }
    })

    const topLevelItem = ref(null)

    const toggleExpanded = () => {
        isExpanded.value = !isExpanded.value
    }
    const isExpanded = ref(false)

    const notificationCountClass = computed(() => {
        const classes = [];

        if (props.notificationCount > 0) {
            classes.push('scale-100');
        } else {
            classes.push('scale-0 opacity-0');
        }

        if (props.notificationCount > 1) {
            if (props.notificationCount > 99) {
                classes.push('w-5 h-4 border-2 border-wlPrimary top-2 -right-2.5');
            } else {
                classes.push('w-4 h-4 border-2 border-wlPrimary top-2 -right-2');
            }
        } else {
            classes.push('w-3 h-3 top-3 -right-1.5');
        }

        return classes.join(' ');
    })

    const isActive = computed(() => {
        let active = false
        if (route().current(props.item.routeName, props.item.routeParams)) {
            active = true
        }
        props.item.subItems?.forEach(subItem => {
            if(route().current(subItem.routeName, subItem.routeParams)) {
                active = true
            }
        })
        props.item.activeRoutes?.forEach(subItem => {
            if(route().current(subItem, props.item.routeParams)) {
                active = true
            }
        })
        return active
    })

</script>
<template>
    <li
        v-if="Object.keys(item).length > 0"
        class="relative group pb-1"
    >
        <div
            class="relative flex justify-between items-center group"
            :class="item.active ? 'opacity-100' : 'opacity-50'"
        >
            <div
                :class="notificationCountClass"
                class="absolute z-10 flex items-center justify-center overflow-hidden leading-none transition-all rounded-full cursor-default bg-wlPrimary text-wlPrimaryContrast"
                style="font-size: 8px;"
            >
                {{ notificationCount === 1 ? '' : notificationCount }}
            </div>
            <a
                :href="item.active ? item.href : '#'"
                :aria-current="isActive ? 'page' : undefined"
                class="flex space-x-1 items-start pl-3"
            >
                <div>
                    <div
                        class="text-xs pt-0.5 text-wlLink font-semibold"
                        :class="[item.active ? 'hover:underline' : '', isActive ? 'text-wlPrimary' : '']"
                    >
                        {{ _mft(item.name) }}
                    </div>
                </div>
            </a>
        </div>
        <div
            v-if="(!isActive && !isExpanded) && item.byline"
            class="pl-7 pr-2 -mt-0.5 text-xxs text-gray-400"
        >
            {{ item.byline }}
        </div>
        <ul
            v-if="item.active"
        >
            <SidebarNavigationSubItem
                v-for="item in item.subItems"
                v-bind:key="item.name"
                :item="item"
            />

            <li
                v-if="item.primaryCallToAction"
                class="absolute -top-1 right-2 opacity-0 -translate-x-4 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-100"
            >
                <a
                    :href="item.primaryCallToAction.href"
                    class="relative z-30 block text-xs w-full"
                >
                    <button-primary
                        size="xs"
                        class="justify-center -ml-1 mt-1"
                    >
                        {{ _mft(item.primaryCallToAction.name) }}
                    </button-primary>
                </a>
            </li>
        </ul>
    </li>
</template>
